import {createDateTimeFormatter, type DateTimeFormatter} from '@fitro/date-time'

// Calendar labels have a fixed Polish locale and never convert a date to an instant.
export const POLISH_PUBLIC_DATE_TIME = createDateTimeFormatter({locale: 'pl-PL', timeZone: 'UTC'})

export function polishPublicDateTimeInZone(timeZone: string): DateTimeFormatter {
    return createDateTimeFormatter({locale: 'pl-PL', timeZone})
}
